export { QuizFooter, QuizFooterRow } from './QuizFooter';
export { default } from './QuizFooter';
